var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "bill-detail-wrap"
    },
    [
      _c("div", { staticClass: "top same-content" }, [
        _c("div", { staticClass: "content-title" }, [
          _vm._v("\n      概览\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top-content same-padding" }, [
          _c("div", { staticClass: "top-item" }, [
            _c("span", [_vm._v("承运方：")]),
            _c("span", [_vm._v(_vm._s(_vm.details.carrier))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-item" }, [
            _c("span", [_vm._v("订单数：")]),
            _c("span", [
              _vm._v(
                _vm._s(_vm.details.general && _vm.details.general.orderNoCnt)
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-item" }, [
            _c("span", [_vm._v("费用单数：")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.details.general && _vm.details.general.accrualBasisCnt
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-item" }, [
            _c("span", [_vm._v("账单号：")]),
            _c("span", [_vm._v(_vm._s(_vm.billNo))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-item" }, [
            _c("span", [_vm._v("账单生成时间：")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm._f("timeFormat")(
                    _vm.details.operation && _vm.details.operation.createTime
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-item" }, [
            _c("span", [_vm._v("金额：")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.details.general && _vm.details.general.realTotalMoney
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-item" }, [
            _c("span", [_vm._v("已付金额：")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.details.general && _vm.details.general.processedMoney
                )
              )
            ])
          ]),
          _vm._v(" "),
          _vm.details.general &&
          _vm.details.general.receiptAndPaymentStatus === "未付款"
            ? _c("div", { staticClass: "top-item" }, [
                _c("span", [_vm._v("待付金额：")]),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.details.general && _vm.details.general.pendingMoney
                    )
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "top-item" }, [
            _c("span", [_vm._v("状态：")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.details.general &&
                    _vm.details.general.receiptAndPaymentStatus
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-item" }, [
            _c("span", [_vm._v("流水：")]),
            _c(
              "span",
              {
                class: [_vm.isOld ? "" : "link-url"],
                on: { click: _vm.toRunningAccountCnt }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.details.general && _vm.details.general.runningAccountCnt
                  )
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom same-content" }, [
        _c("div", { staticClass: "content-title" }, [
          _vm._v("\n      明细\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "same-padding bottom-content" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, border: "" }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "name", label: "费用名称", align: "center" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "totalMoney",
                    label: "费用金额",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "accrualBasisNo",
                    label: "费用号",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "span",
                            {
                              class: [_vm.isOld ? "" : "link-url"],
                              on: {
                                click: function($event) {
                                  return _vm.toCost(scope.row.accrualBasisNo)
                                }
                              }
                            },
                            [_vm._v(_vm._s(scope.row.accrualBasisNo))]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2d68f8b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2d68f8b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/bill/detail/index.vue
// module id = null
// module chunks = 